module.exports = __webpack_public_path__ + "img/main.f10bac93.jpg";